import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import {MatDialog} from '@angular/material/dialog';
// import { PaymentStatusModelComponent } from '../../../payment/payment-status-model/payment-status-model.component';

@Component({
  selector: 'app-us-payment-list',
  templateUrl: './us-payment-list.component.html'
})
export class UsPaymentListComponent implements OnInit {
  data:any=[];
  autoFocus?: boolean = true;
  constructor(private _location: Location, public dialog: MatDialog) { }

  ngOnInit() {
    this.data = [
      {
        "date":"28 May 2020",
        "createby":"Satender Bhati",
        "value":"5,00,000",
        "cus":"Amit Saini",
        "mobile":"9989891234",
        "type":"NEFT",
        "tran":"| TXN : 9854785412781458",
        "statusclr":"green-clr",
        "status":"Received",
      },
      {
        "date":"27 May 2020",
        "createby":"Shivam Kumar",
        "value": "3,50,000",
        "cus":"Deepak Gupta",
        "mobile":"8010025732",
        "type":"Cash",
        "statusclr":"yellow-clr",
        "status":"Pending",
      },
      {
        "date":"26 May 2020",
        "createby":"Kapil Raghav",
        "value": "2,10,000",
        "cus":"Shyam Yadav",
        "mobile":"9078456712",
        "type":"NEFT",
        "tran":"| TXN : 9854785412787890",
        "statusclr":"green-clr",
        "status":"Received",
      },
      {
        "date":"26 May 2020",
        "createby":"Sanjay Singh",
        "value": "1,80,000",
        "cus":"Naresh Gupta",
        "mobile":"7867561219",
        "type":"NEFT",
        "tran":"| TXN : 9854785412785512",
        "statusclr":"green-clr",
        "status":"Received",
      },
      {
        "date":"25 May 2020",
        "createby":"Anil Verma",
        "value": "6,25,000",
        "cus":"Harish Kumar",
        "mobile":"9570671278",
        "type":"Cash",
        "statusclr":"yellow-clr",
        "status":"Pending",
      },
      {
        "date":"24 May 2020",
        "createby":"Jatin Sharma",
        "value":"2,50,000",
        "cus":"Naresh",
        "mobile":"9054126712",
        "type":"NEFT",
        "tran":"| TXN : 9854785412781024",
        "statusclr":"green-clr",
        "status":"Received",
      },
      {
        "date":"23 May 2020",
        "createby":"Anil Saini",
        "value": "3,50,000",
        "cus":"Gautam Kumar",
        "mobile":"9878459065",
        "type":"Cash",
        "statusclr":"yellow-clr",
        "status":"Pending",
      },
      {
        "date":"23 May 2020",
        "createby":"Ramesh Sharma",
        "value": "2,10,000",
        "cus":"A.P. Mehra",
        "mobile":"9313459067",
        "type":"Cash",
        "statusclr":"yellow-clr",
        "status":"Pending",
      },
      {
        "date":"22 May 2020",
        "createby":"Anoop Singla",
        "value": "1,80,000",
        "cus":"Parshant Singh",
        "mobile":"9213674560",
        "type":"NEFT",
        "tran":"| TXN : 9854785412781070",
        "statusclr":"green-clr",
        "status":"Received",
      },
      {
        "date":"21 May 2020",
        "createby":"Vinay Gupta",
        "value": "1,55,000",
        "cus":"Anil Jain",
        "mobile":"9967891256",
        "type":"Cash",
        "statusclr":"yellow-clr",
        "status":"Pending",
      },
    ];
  }
  backClicked() {
    this._location.back();
  }

  openStatusDialog(): void {
    // const dialogRef = this.dialog.open(PaymentStatusModelComponent, {
    //   width: '500px',
    //   autoFocus: false,
    //   data: {}
    // });

    // dialogRef.afterClosed().subscribe(result => {
    //   console.log('The dialog was closed');
    // });
  }

}
